
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function ACfourtfive() {



    const cardData =
    {
        keyword: 'Ac 45 Seater Bharat Benz Hire in Pune',
        heading: 'Amruta Travels: Ac 45 Seater Bharat Benz Hire in Pune',
        headingDescription: 'Amruta Travels offers AC 45 Seater BharatBenz Hire in Pune, delivering a premium and spacious travel experience for large groups. Whether it is a corporate outing, wedding function, school trip, or intercity tour, our 45-seater AC BharatBenz buses are designed for maximum comfort and reliability. Enjoy plush seating, air-conditioned interiors, and smooth rides backed by our professional drivers and punctual service. With affordable pricing, 24/7 availability, and a strong reputation for quality, Amruta Travels ensures your journey is safe, luxurious, and hassle-free.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',


  "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Located around 120 km from Pune, Mahabaleshwar is a picturesque hill station in the Western Ghats, known for its cool climate, evergreen forests, and stunning viewpoints such as Arthur’s Seat, Wilson Point (the highest point), and Kate's Point. The region is famous for its strawberry farms, especially during the Strawberry Festival held in spring. Other attractions include Venna Lake for boating, Mapro Garden for strawberry-based treats, and ancient temples like Panchganga and Mahabaleshwar Temple. It's a popular destination for families, honeymooners, and nature enthusiasts seeking a refreshing escape from city life."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range offer a perfect blend of natural beauty and adventure. Lonavala is known for its misty mountains, lush greenery, and monsoon waterfalls like Kune and Bhivpuri. Attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla & Bhaja Caves. Khandala is equally famous for its panoramic valley views and trekking routes. The area is ideal for a weekend drive, with scenic routes and roadside chikki stalls that add to the charm of this quick getaway."
    },
    {
      "title": "Shirdi",
      "description": "About 190 km from Pune, Shirdi is a sacred town revered by followers of Sai Baba. The Sai Baba Samadhi Mandir is the main attraction, drawing millions of devotees every year. Pilgrims can also visit Dwarkamai, Chavadi, and the Sai Heritage Village. The spiritual ambiance, combined with well-maintained infrastructure and religious events, makes Shirdi a prominent destination for those seeking peace, healing, and spiritual growth."
    },
    {
      "title": "Goa",
      "description": "Located nearly 450 km from Pune, Goa is India’s premier beach destination, known for its lively culture, golden beaches, and Portuguese heritage. From North Goa’s party hotspots like Baga, Anjuna, and Calangute to South Goa’s serene stretches like Palolem and Colva, there’s a vibe for every traveler. Apart from beaches, visitors can explore Aguada Fort, Basilica of Bom Jesus, spice plantations, vibrant flea markets, and indulge in thrilling water sports. Goa is also a haven for foodies, offering authentic seafood, Goan curries, and beachside shacks serving refreshing cocktails."
    },
    {
      "title": "Nashik",
      "description": "Around 210 km from Pune, Nashik is a city of immense cultural, historical, and spiritual significance. It is one of the four cities where the Kumbh Mela is held. Attractions include the ancient Kalaram Temple, Muktidham Temple, Pandavleni Caves, and Trimbakeshwar Temple—an important Jyotirlinga. Nashik is also the wine capital of India, home to Sula Vineyards, York Winery, and many tasting tours. The Godavari River adds to its charm, making it a harmonious blend of spirituality and leisure tourism."
    },
    {
      "title": "Alibaug",
      "description": "Situated about 140 km from Pune, Alibaug is a tranquil coastal town offering a perfect mix of beaches, history, and nature. Popular beaches include Nagaon, Alibaug Beach, and Kashid Beach, all great for swimming, sunbathing, and water sports. The iconic Kolaba Fort, accessible during low tide, adds historical value to the destination. You can also explore Korlai Fort, Kanakeshwar Temple, and local seafood cuisine. Ideal for weekend trips, Alibaug also offers ferry services from Mumbai for added convenience."
    },
    {
      "title": "Kolhapur",
      "description": "Roughly 235 km from Pune, Kolhapur is a vibrant city known for its divine Mahalaxmi Temple, which draws pilgrims throughout the year. The city is equally famous for its spicy cuisine, Kolhapuri chappals, and traditional arts. Attractions include Rankala Lake for evening strolls, Panhala Fort offering panoramic views, and the New Palace Museum showcasing royal heritage. With its rich cultural identity and warm hospitality, Kolhapur is ideal for heritage and culinary tourism."
    },
    {
      "title": "Lavasa",
      "description": "Just 60 km from Pune, Lavasa is an Italian-inspired planned city nestled in the Sahyadri hills. It features beautiful waterfronts, European-style architecture, and a peaceful atmosphere perfect for a quick weekend escape. Activities include kayaking, zip-lining, and lakeside cycling. With cozy resorts, conference centers, and nature trails, Lavasa attracts both families and corporate travelers. The weather remains pleasant most of the year, enhancing its appeal as a rejuvenating destination close to Pune."
    },
    {
      "title": "Satara & Kaas Plateau",
      "description": "About 120 km from Pune, Satara serves as the base for exploring the Kaas Plateau—popularly known as the 'Valley of Flowers' of Maharashtra. The plateau, a UNESCO World Natural Heritage site, bursts into a riot of colors with over 850 species of wildflowers during the monsoon season. Satara is also known for Ajinkyatara Fort, Thoseghar Waterfalls, and Sajjangad Fort. The natural beauty and biodiversity make this region a paradise for trekkers, botanists, and photographers."
    },
    {
      "title": "Aurangabad",
      "description": "Situated 235 km from Pune, Aurangabad is a historical treasure trove, offering insights into ancient art, architecture, and culture. The city is home to the world-famous Ajanta and Ellora Caves, adorned with exquisite carvings and paintings dating back to 2nd century BCE. Other attractions include Bibi Ka Maqbara (a replica of the Taj Mahal), Daulatabad Fort, and Aurangabad Caves. The city is also a gateway to Grishneshwar Jyotirlinga and Paithani saree shopping, making it a must-visit for heritage lovers."
    }
  ],

  "services": [
    {
      "name": "AC 45 Seater Bharat Benz Bus Hire Pune",
      "description": "Amruta Travels offers AC 45-seater Bharat Benz buses for hire in Pune, ideal for large group outings, weddings, school picnics, and corporate events with luxurious comfort and safety."
    },
    {
      "name": "45 Seater Luxury Bus on Rent",
      "description": "Rent a 45-seater luxury bus in Pune with Amruta Travels for premium travel comfort. Ideal for weddings, conferences, and long-distance travel with AC, pushback seats, and professional service."
    },
    {
      "name": "45 Seater AC Bus Rental in Pune",
      "description": "Book 45-seater AC buses in Pune for smooth and comfortable transportation. Amruta Travels ensures reliability and convenience for corporate events, tours, and functions."
    },
    {
      "name": "Bharat Benz 45 Seater Bus for Outstation",
      "description": "Planning an outstation trip? Amruta Travels provides 45-seater Bharat Benz buses equipped for long-distance travel with comfort, AC, and safety features for your group."
    },
    {
      "name": "Pune 45 Seater AC Bus for Marriage",
      "description": "Make wedding travel stress-free with our 45-seater AC Bharat Benz buses. Spacious and comfortable, they are perfect for transporting guests between venues in Pune or nearby locations."
    },
    {
      "name": "Corporate Events AC Bus Rental",
      "description": "Amruta Travels offers premium 45-seater AC buses for corporate events. Ideal for conferences, seminars, and office trips, with punctual service and modern amenities."
    },
    {
      "name": "45 Seater AC Bus Hire Pimpri Chinchwad",
      "description": "Hire 45-seater AC buses in Pimpri Chinchwad with Amruta Travels. Perfect for local or outstation trips for schools, offices, or family events with reliable and comfortable service."
    },
    {
      "name": "45 Seater Bus for School Picnic",
      "description": "Book a 45-seater Bharat Benz bus for school picnics in Pune. Our buses ensure safety, comfort, and punctuality for hassle-free student travel experiences."
    },
    {
      "name": "45 Seater AC Bus for Corporate Office Trips",
      "description": "Amruta Travels offers efficient corporate office transport solutions with 45-seater AC buses. Ensure a comfortable and timely commute for employee travel and corporate visits."
    },
    {
      "name": "AC Bharat Benz 45 Seater for Wedding Events",
      "description": "Rent a luxury 45-seater AC Bharat Benz bus for your wedding events in Pune. Comfortable seating and AC interiors make it a perfect option for guest transportation."
    },
    {
      "name": "45 Seater Bus Hire for Conferences",
      "description": "Hire 45-seater Bharat Benz buses for conferences, exhibitions, or corporate meetups. Amruta Travels ensures professional, timely, and comfortable travel experiences."
    },
    {
      "name": "Bharat Benz Bus Hire in Hadapsar",
      "description": "Looking for a bus in Hadapsar? Amruta Travels provides Bharat Benz 45-seater buses for all occasions, including weddings, school trips, and corporate events."
    },
    {
      "name": "45 Seater Bus for Pune to Mumbai",
      "description": "Travel from Pune to Mumbai with ease in our 45-seater AC buses. Ideal for group trips, corporate travel, or weddings, with smooth and comfortable rides guaranteed."
    },
    {
      "name": "Pune to Goa AC Bus Hire",
      "description": "Planning a Goa trip from Pune? Amruta Travels offers AC 45-seater buses ideal for group travel, with luxury interiors and experienced drivers for a fun journey."
    },
    {
      "name": "Pune to Shirdi 45 Seater Bus Hire",
      "description": "Visit Shirdi with our comfortable 45-seater buses. Amruta Travels ensures a peaceful and safe religious journey with AC buses and experienced drivers."
    },
    {
      "name": "Luxury Bharat Benz Coach in Pune",
      "description": "Experience high-end group travel with Amruta Travels' luxury Bharat Benz coaches in Pune. Suitable for weddings, tours, or business events with AC and premium interiors."
    }
  ],
  "tableData": [
    ["AC 45 Seater Bharat Benz Bus Hire Pune", "45 Seater Luxury Bus on Rent"],
    ["45 Seater AC Bus Rental in Pune", "Bharat Benz 45 Seater Bus for Outstation"],
    ["Pune 45 Seater AC Bus for Marriage", "Corporate Events AC Bus Rental"],
    ["45 Seater AC Bus Hire Pimpri Chinchwad", "45 Seater Bus for School Picnic"],
    ["45 Seater AC Bus for Corporate Office Trips", "AC Bharat Benz 45 Seater for Wedding Events"],
    ["45 Seater Bus Hire for Conferences", "Bharat Benz Bus Hire in Hadapsar"],
    ["45 Seater Bus for Pune to Mumbai", "Pune to Goa AC Bus Hire"],
    ["Pune to Shirdi 45 Seater Bus Hire", "Luxury Bharat Benz Coach in Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Spacious AC 45 Seater Bharat Benz Bus on Hire in Pune",
    "WhyChoosedescription": "Amruta Travels offers AC 45 Seater Bharat Benz buses on hire in Pune, perfect for large group travel. Whether it’s a corporate conference, school excursion, or wedding transportation, our Bharat Benz buses ensure a seamless group travel experience."
  },
  {
    "WhyChooseheading": "Comfortable and Air-Conditioned Travel for Large Groups",
    "WhyChoosedescription": "Our AC 45 Seater Bharat Benz buses come equipped with powerful air conditioning, reclining seats, and ample legroom, providing a comfortable ride for long or short journeys across Pune and beyond."
  },
  {
    "WhyChooseheading": "Modern Fleet with Essential Onboard Amenities",
    "WhyChoosedescription": "These buses feature modern interiors, clean upholstery, wide windows, and luggage storage, ensuring convenience and comfort for all passengers throughout the trip."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing Structure",
    "WhyChoosedescription": "We offer competitive and transparent rates for AC 45 Seater Bharat Benz rentals. Our pricing includes fuel, tolls, taxes, and driver allowance—no hidden costs, making it easy to plan your travel budget."
  },
  {
    "WhyChooseheading": "Expert Drivers for Safe and Smooth Journeys",
    "WhyChoosedescription": "All our drivers are professionally trained, experienced, and well-versed with Pune’s routes and major outstation destinations. They prioritize safety, punctuality, and customer satisfaction."
  },
  {
    "WhyChooseheading": "Ideal for Weddings, Corporate Events, and Tours",
    "WhyChoosedescription": "The 45 Seater Bharat Benz bus is ideal for wedding guest transfers, corporate travel, educational tours, and pilgrimage trips—offering a blend of capacity, comfort, and reliability."
  },
  {
    "WhyChooseheading": "Regularly Maintained for Optimal Performance",
    "WhyChoosedescription": "Our fleet is well-maintained, sanitized, and undergoes routine mechanical checks. This ensures every ride is smooth, hassle-free, and up to the highest safety standards."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking with 24/7 Customer Assistance",
    "WhyChoosedescription": "Amruta Travels provides simple booking options through phone, online, or office visits. Our 24/7 customer support is ready to help you with bookings, queries, and customized travel plans."
  }
]















    }

const faqData = [
  {
    question: 'Can I rent an AC 45-seater Bharat Benz bus in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers AC 45-seater Bharat Benz buses for rent in Pune. These buses are ideal for large groups traveling for corporate events, family outings, pilgrimages, and more.',
  },
  {
    question: 'What amenities are available in the AC 45-seater Bharat Benz bus?',
    answer: 'Our AC 45-seater Bharat Benz buses come with plush seating, air conditioning, modern entertainment systems, ample luggage space, and a clean, comfortable interior for a pleasant journey.',
  },
  {
    question: 'Is the AC 45-seater Bharat Benz bus available for both local and outstation travel?',
    answer: 'Yes, the AC 45-seater Bharat Benz bus is available for both local city travel in Pune as well as long-distance outstation trips to destinations like Mumbai, Lonavala, Mahabaleshwar, and more.',
  },
  {
    question: 'Is a driver included in the Bharat Benz bus rental?',
    answer: 'Yes, all Bharat Benz bus rentals from Amruta Travels come with an experienced, licensed driver who ensures safe, timely, and comfortable travel for all passengers.',
  },
  {
    question: 'How much does it cost to rent an AC 45-seater Bharat Benz bus in Pune?',
    answer: 'Rental charges depend on factors such as distance, trip duration, and services required. Typically, rates start from ₹70 per km. Contact us for a customized quote based on your itinerary.',
  },
  {
    question: 'Is the AC 45-seater Bharat Benz bus comfortable for long journeys?',
    answer: 'Yes, the AC 45-seater Bharat Benz bus is designed to offer a comfortable ride with ample legroom, quality seating, and an air-conditioned environment, making it perfect for long journeys.',
  },
  {
    question: 'Are the AC 45-seater Bharat Benz buses well-maintained and sanitized?',
    answer: 'Absolutely. All our buses, including the AC 45-seater Bharat Benz, are regularly inspected, cleaned, and sanitized before each trip to ensure the highest standards of hygiene and safety.',
  },
  {
    question: 'How do I book an AC 45-seater Bharat Benz bus in Pune?',
    answer: 'You can easily book an AC 45-seater Bharat Benz bus by visiting our website or contacting our customer support team. We offer quick booking assistance and transparent pricing.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Rahul Deshmukh',
    role: 'Corporate Manager, Pune',
    text: 'We rented an AC 45-seater Bharat Benz bus from Amruta Travels for a corporate team outing. The bus was spacious, clean, and the air conditioning made the long trip extremely comfortable. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Priya Joshi',
    role: 'Event Coordinator',
    text: 'I booked an AC 45-seater Bharat Benz bus for a wedding guest transport. The service was excellent, the bus was well-maintained, and everyone had a comfortable experience. Would definitely use Amruta Travels again.',
    rating: 5,
  },
];























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "AC 45 Seater Bharat Benz Hire in Pune",
  "image": "https://bushireinpune.com/assets/images/45-seater-bharat-benz-bus.jpg",
  "description": "Amruta Travels offers AC 45 Seater Bharat Benz Bus Hire in Pune for luxury travel. Perfect for weddings, corporate office trips, school picnics, outstation tours to Mumbai, Goa, Shirdi, and conferences. Our Bharat Benz coach features spacious interiors, air-conditioning, and professional drivers for a comfortable journey.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "10025"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6500",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/ac-45-seater-bharat-benz-hire-pune"
  }
};






    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | AC 45 Seater Bharat Benz Hire in Pune | Luxury Bus for Wedding & Corporate Travel</title>
  <meta 
    name="description" 
    content="Book AC 45 Seater Bharat Benz Bus in Pune for corporate events, weddings, school trips, or outstation travel like Pune to Goa, Shirdi, or Mumbai. Get luxury coach rental from Amruta Travels with professional drivers." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/84.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default ACfourtfive;